'use strict';

global.utl = require('../utils.js');
global.offset = 24;

var limit = 4;
var limitMoodborad = global.offset;
var blocksLimit = {
  'a': '3',
  'b': '4',
  'c': '3',
  'd': '2'
};
var loaded = false;
var finish = false;
var init = true;

var self = module.exports = {
  init: function () {
    if (init == true) {
      self.initMoodboard(0, limitMoodborad);
      self.existMore(global.offset, 1);
    }

    $(window).scroll(function() {
      var end = $("#load-more").offset().top;
      var viewEnd = $(window).scrollTop() + $(window).height();
      var distance = end - viewEnd;

      if (distance < 100 && loaded == false && finish == false && init == false) {
        self.loaded();
        self.loadMore(global.offset, limit);
        self.existMore(global.offset + limit, 1);
      }
    });
  },

  loaded: function() {
    loaded = true;
  },

  initMoodboard: function(offset, limit) {
    $.ajax({
      method: 'GET',
      url: '/rest/widgets/widgettext,widgetoffprint/news_landing/' + offset + ',' + limit + '/position,asc'
    }).done(function(data) {
      (function(data, offset) {
        var blocks = {};

        data.forEach(function(widget, i) {

          var block = widget.block;

          if (!blocks.hasOwnProperty(block)) {
            blocks[widget.block] = [];
          }

          blocks[widget.block].push(widget);

        });

        for (var i = 1; i <= 3; i++) {

          Object.keys(blocks).forEach(function(key) {

            var wrapper = $('.news-section_' + i).find('.landing-wrapper-' + key);
            var template = $('#news-template-' + key).html();
            var widgetsRange = blocks[key].slice(((blocksLimit[key] * i) - blocksLimit[key]), (blocksLimit[key] * i));

            if (widgetsRange.length > 0) {
              mustache.parse(template);
              var rendered = mustache.render(template, {'widgets': widgetsRange});
            }

            wrapper.append(rendered);

          });

        }

        $('.news-module__date').each(function(i, element) {
          //console.log($(element).attr('datetime'));
          var text = $(element).attr('datetime').trim().replace(/ /g,'T');
          var dateWidget = new Date(text);
          var dateFormatWidget = dateWidget.getDate() + ' ' + utl.getMonthName(dateWidget) + ' ' + dateWidget.getFullYear();
          $(element).text(dateFormatWidget);
        });

        $(document).foundation();
        loaded = false;
        init = false;

      })(data, offset);
    });
  },

  loadMore: function(offset, limit) {
    $.ajax({
      method: 'GET',
      url: '/rest/widgets/widgettext,widgetoffprint/news_landing/' + offset + ',' + limit + '/position,asc'
    }).done(function(data) {
      (function(data, offset) {
        var template = $('#news-template-e').html();
        var wrapper = $('.landing-wrapper-e');
        global.offset += data.length;

        mustache.parse(template);
        var rendered = mustache.render(template, {'widgets': data});

        wrapper.append(rendered);

        $(document).foundation();

        var moodboard = wrapper.find('.landing-moodboard');

        $.each(moodboard, function(key, group) {
          var modules = $(group).find('.news-module');

          if (key == moodboard.length - 1) {

            $.each(modules, function(key, element) {
              // var text = $(element).find('.news-module__date').text().replace(/\s/g, '').replace('00:00:00.000000', '');
              var text = $(element).find('.news-module__date').attr('datetime').trim().replace(/ /g,'T');
              var dateWidget = new Date(text);
              var dateFormatWidget = dateWidget.getDate() + ' ' + utl.getMonthName(dateWidget) + ' ' + dateWidget.getFullYear();
              $(element).find('.news-module__date').text(dateFormatWidget);
            });
          }
        });

        loaded = false;
        init = false;

      })(data, offset);
    });
  },

  existMore: function(offset, limit) {
    $.ajax({
      method: 'GET',
      url: '/rest/widgets/widgettext,widgetoffprint/news_landing/' + offset + ',' + limit + '/position,asc'
    }).done(function(data) {
      (function(data, offset) {
        if (data.length > 0) {
          $('#load-more').removeClass('hide');
        } else {
          finish = true;
          $( document ).ajaxStop(function() {
              $('#load-more').addClass('hide');
          });
        }
      })(data, offset);
    });
  }
};

self.init();
